import storageService from "@/services/storage.service";
// Authentication Vuex state module
export const state = {
  currentUser: storageService.getSessionItem("authUser"),
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
  },
};

export const getters = {
  loggedIn(state) {
    return !!state.currentUser;
  },
};

export const actions = {
  init() {},
  logIn({ commit }, user) {
    commit("SET_CURRENT_USER", user);
    return user;
  },
  logOut({ commit }) {
    commit("SET_CURRENT_USER", null);
    return Promise.resolve(true);
  },
};
